<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"
	><title>Social_Linkedin_G</title>
	<path
		d="M8.2,1a7.2,7.2,0,1,0,7.2,7.2A7.2,7.2,0,0,0,8.2,1ZM62.7,34.4c-1-7.8-4.5-12.7-15.1-12.7-6.2,0-10.4,2.3-12.1,5.6H35.2V21.7H23.7V63H35.8V42.5c0-5.4,1.1-10.6,7.7-10.6s7.1,6.2,7.1,11V63H63V40.3A48.4,48.4,0,0,0,62.7,34.4ZM1,32.6V63H15.5V21.7H1v11Z"
	></path></svg
>
